import React from "react";

const TicketPage = () => {
  return (
    <div className="container-xs">
      <h3>Problem with my APIs...</h3>
      <p className="text-small text-muted mb-4">04/01/2021, 16:12</p>

      <div className="d-flex">
        <div>
          <p className="text-muted mb-1">Original poster</p>
          <p>
            Nick Sotiriadis - National Bank of Greece
            <br />
            <a className="link-color" href="mailto:nsotiriadis@finclude.ai">
              nsotiriadis@finclude.ai
            </a>
          </p>
        </div>
        <div className="ml-auto mb-3">
          <p className="text-muted mb-1">
            Status -{" "}
            <strong className="text-small text-body">Waiting for reply</strong>
          </p>
          <select className="fin-control fin-control-sm w-200">
            <option>Change Status</option>
            <option>Close</option>
            <option>Resolve</option>
          </select>
          {/*<p>Replied</p>*/}
        </div>
      </div>

      <hr className="mt-45 mb-45" />

      <div className="post">
        <div className="d-flex mb-3">
          <h6 className="mb-0">
            Nick Sotiriadis -{" "}
            <span className="text-small text-link-alt">Started topic</span>
          </h6>
          <p className="text-xsmall text-muted ml-auto">04/01/2021, 16:12</p>
        </div>
        <p>
          Id et consectetur ab iis est familiaritatem quo ad et cillum constias
          id irure consequat admodum ita sed proident illustriora ab quis
          constias do aliqua dolore aut ad occaecat tractavissent, elit ullamco
          transferrem. Sint constias pariatur hic offendit minim quis quo velit,
          commodo fidelissimae te doctrina, export incididunt nescius.
        </p>
        <p>
          Commodo sempiternum aut cernantur id fabulas ex admodum, vidisse
          sempiternum ea officia aut de tamen se dolor, anim deserunt o appellat
          te quid eu ullamco ab duis do consequat dolore quo incididunt
          firmissimum, ut ad sunt fabulas. Aute nam officia te vidisse culpa
          labore non duis. Si export ad quae, aute ab iis fore eiusmod aut ipsum
          quibusdam nam imitarentur, a cupidatat si constias, quo ita enim
          singulis ne ullamco sunt eu ingeniis comprehenderit, sint admodum e
          nisi veniam, mentitum quo tempor eiusmod.
        </p>
      </div>

      <hr className="mt-45 mb-45" />

      <div className="post">
        <div className="d-flex mb-3">
          <h6 className="mb-0">
            You - <span className="text-small text-link-alt">Replied</span>
          </h6>
          <p className="text-xsmall text-muted ml-auto">04/01/2021, 17:12</p>
        </div>
        <p>
          Id et consectetur ab iis est familiaritatem quo ad et cillum constias
          id irure consequat admodum ita sed proident illustriora ab quis
          constias do aliqua dolore aut ad occaecat tractavissent.
        </p>
      </div>

      <hr className="mt-45 mb-45" />

      <div className="post">
        <div className="d-flex mb-3">
          <h6 className="mb-0">
            You -{" "}
            <span className="text-small text-link-alt">Marked as Resolved</span>
          </h6>
          <p className="text-xsmall text-muted ml-auto">04/01/2021, 17:12</p>
        </div>
      </div>

      <hr className="mt-45 mb-45" />

      <div className="post">
        <div className="d-flex mb-3">
          <h6 className="mb-0">
            Nick Sotiriadis -{" "}
            <span className="text-small text-link-alt">
              Reopened and replied
            </span>
          </h6>
          <p className="text-xsmall text-muted ml-auto">04/01/2021, 17:12</p>
        </div>
        <p>
          Id et consectetur ab iis est familiaritatem quo ad et cillum constias
          id irure consequat admodum ita sed proident illustriora ab quis
          constias do aliqua dolore aut ad occaecat tractavissent.
        </p>
      </div>

      <div className="mt-5">
        <textarea className="fin-control mb-3" placeholder="Type your reply" />
        <a className="btn btn-sm btn-main">Reply</a>{" "}
        <a href="#" className="btn btn-sm btn-ghost">
          Reply and Resolve
        </a>
      </div>
    </div>
  );
};

export default TicketPage;
